import { render, staticRenderFns } from "./TopicTemplate.vue?vue&type=template&id=f8940d86&scoped=true"
import script from "./TopicTemplate.vue?vue&type=script&lang=js"
export * from "./TopicTemplate.vue?vue&type=script&lang=js"
import style0 from "./TopicTemplate.vue?vue&type=style&index=0&id=f8940d86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8940d86",
  null
  
)

export default component.exports